module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "tile is-ancestor"
  }, _vm._l((_vm.menu), function(item) {
    return (!item.meta.nomenu) ? _c('div', {
      key: item.meta.label,
      staticClass: "tile is-parent is-2"
    }, [_c('article', {
      staticClass: "tile is-child box"
    }, [_c('router-link', {
      attrs: {
        "to": item.path
      }
    }, [_c('p', {
      staticClass: "title"
    }, [_vm._v(_vm._s(item.meta.label || item.name))]), _vm._v(" "), _c('div', {
      staticClass: "sub-children"
    }, _vm._l((item.children), function(subItem) {
      return (!subItem.meta.nomenu) ? _c('p', {
        key: subItem.meta.label,
        staticClass: "subtitle"
      }, [_c('router-link', {
        attrs: {
          "to": item.path + '/' + subItem.path
        }
      }, [_vm._v("\n                " + _vm._s(subItem.meta.label) + "\n              ")])], 1) : _vm._e()
    }), 0)])], 1)]) : _vm._e()
  }), 0)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-646ebffe"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Home.vue
// module id = 644
// module chunks = 25